// @flow
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import type Moment from "moment";
import SelecaoDeflator from "./SelecaoDeflator";
import SelecaoNormalizacao from "./SelecaoNormalizacao";
import {
  type State,
  i18n,
  getPeriodoUnicoSelecionado,
  getValorBaseDeflatorOutroSelecionado,
  getValorBaseDeflatorSelecionado,
  getDataBaseDeflatorSelecionado,
  getDataBaseDeflatorEspecificaSelecionada,
} from "../../../../state";
import {
  type Id,
  ID_PERIODO_ANALISE_HORIZONTAL,
  ID_VALOR_BASE_DEFLATOR_OUTRO,
  ID_VALOR_BASE_DEFLATOR_NENHUM,
  ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
  ID_DATA_BASE_DEFLATOR_NENHUM,
} from "../../../../model";

type Props = {
  periodoUnicoSelecionado: ?Id,
  exibir: boolean,
  exibirNormalizacao?: boolean,
  forcarExibirNormalizacao?: boolean,
  exibirOpcaoNenhum?: boolean,
  exibirLabelLegado?: boolean,
};

const exibirSelecaoDeflacao: (state: State) => boolean = (state: State) =>
  getPeriodoUnicoSelecionado(state) !== ID_PERIODO_ANALISE_HORIZONTAL;

function SelecaoDeflacao({
  periodoUnicoSelecionado,
  exibir,
  exibirNormalizacao = true,
  forcarExibirNormalizacao = false,
  exibirOpcaoNenhum = false,
  exibirLabelLegado = false,
}: Props) {
  if (!exibir) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida">
      <div className="ConfiguracaoMedida--flex">
        <SelecaoDeflator exibirLabelLegado={exibirLabelLegado} />
      </div>

      <SelecaoNormalizacao
        exibir={exibirNormalizacao}
        forcarExibirNormalizacao={forcarExibirNormalizacao}
        exibirOpcaoNenhum={exibirOpcaoNenhum}
      />
    </div>
  );
}

export const criarFuncaoValidacaoSelecaoDeflacao = (state: State) => () => {
  if (!exibirSelecaoDeflacao(state)) {
    return null;
  }

  const { translate } = i18n(state);

  const valorBaseDeflatorSelecionado: ?Id =
    getValorBaseDeflatorSelecionado(state) ?? null;
  const valorBaseDeflatorOutro: ?number =
    getValorBaseDeflatorOutroSelecionado(state) ?? null;
  const dataBaseDeflatorSelecionada: ?Id =
    getDataBaseDeflatorSelecionado(state) ?? null;
  const dataEspecificaSelecionada: ?Moment =
    getDataBaseDeflatorEspecificaSelecionada(state) ?? null;

  const possuiValorBase =
    valorBaseDeflatorSelecionado !== null &&
    valorBaseDeflatorSelecionado !== ID_VALOR_BASE_DEFLATOR_NENHUM;
  const possuiDataBase =
    dataBaseDeflatorSelecionada !== null &&
    dataBaseDeflatorSelecionada !== ID_DATA_BASE_DEFLATOR_NENHUM;

  if (!possuiValorBase && possuiDataBase) {
    return {
      selecaoNormalizacao: translate(
        "configuracaoRelatorio.erroConfiguracaoNormalizacaoValorBaseObrigatorio"
      ),
    };
  } else if (possuiValorBase && !possuiDataBase) {
    return {
      selecaoNormalizacao: translate(
        "configuracaoRelatorio.erroConfiguracaoNormalizacaoDataBaseObrigatoria"
      ),
    };
  }

  if (valorBaseDeflatorSelecionado === ID_VALOR_BASE_DEFLATOR_OUTRO) {
    if (typeof valorBaseDeflatorOutro !== "number") {
      return {
        selecaoValorBaseDeflator: translate(
          "configuracaoRelatorio.valorBaseDeflatorInvalido"
        ),
      };
    }
  }

  if (dataBaseDeflatorSelecionada === ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA) {
    if (!moment.isMoment(dataEspecificaSelecionada)) {
      return {
        selecaoDataEspecifica: translate(
          "configuracaoRelatorio.erroDataEspecificaInvalida"
        ),
      };
    }
  }

  return null;
};

export default connect(
  state => ({
    periodoUnicoSelecionado: getPeriodoUnicoSelecionado(state),
    exibir: exibirSelecaoDeflacao(state),
  }),
  {}
)(SelecaoDeflacao);
